import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ListadosService } from '../../auxiliares/listados.service';
import { WebSocketService } from '../../auxiliares/websocket';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private router: Router,
    private webSocketService: WebSocketService,
    private listadosService: ListadosService,
    private loginService: LoginService
  ) {}

  public logout() {
    this.loginService.removeLoginInfo();
    this.listadosService.borrarCache();
    this.webSocketService.closeWS();
    this.router.navigate(['/login']);
  }
}
